import { Component } from '@angular/core';

@Component({
	selector: 'invoice-contract-question',
	template: require('./invoice-contract-question.html'),
	styles: [require('./invoice-contract-question.scss')]
})
export class InvoiceContractQuestionComponent {
	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/invoices/invoice-update/invoice-contract-question/invoice-contract-question.ts